import { render, staticRenderFns } from "./definir-directorTurma.vue?vue&type=template&id=59b0a49c&"
import script from "./definir-directorTurma.vue?vue&type=script&lang=js&"
export * from "./definir-directorTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports